(() => {
  function init(root) {
    if (root.dataset.categoryReady) return;
    root.dataset.categoryReady = 'true';
    const grid = root.querySelector('[data-category-grid]');
    const count = root.querySelector('[data-category-count]');
    const pagination = root.querySelector('[data-category-pagination]');
    const loading = root.querySelector('[data-category-loading]');
    const status = root.querySelector('[data-category-status]');
    const retry = root.querySelector('[data-category-retry]');
    const total = Number(grid.dataset.categoryTotal);
    let restart = Number(grid.dataset.categoryPage) > 1;
    let next = restart ? grid.dataset.categoryFirstUrl : root.querySelector('[data-category-next]')?.getAttribute('href');
    let running = false;
    const key = card => card.querySelector('h3 a').getAttribute('href');
    let seen = new Set(Array.from(grid.querySelectorAll('[data-category-story]'), key));

    async function loadAll() {
      if (running || !next) return;
      running = true;
      retry.hidden = true;
      loading.hidden = false;
      status.textContent = 'Loading all stories…';
      const visited = new Set();
      try {
        while (next && root.isConnected) {
          const url = new URL(next, window.location.href);
          url.hash = '';
          if (url.origin !== window.location.origin || visited.has(url.href)) throw new Error('Invalid archive page');
          visited.add(url.href);
          const response = await fetch(url.href, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Archive unavailable');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const feed = page.querySelector('[data-category-feed]');
          const cards = feed?.querySelectorAll('[data-category-story]');
          if (!cards?.length) throw new Error('No stories returned');
          if (!root.isConnected) return;
          if (restart) {
            grid.replaceChildren();
            seen = new Set();
            restart = false;
          }
          for (const card of cards) {
            const id = key(card);
            if (seen.has(id)) continue;
            card.querySelectorAll('img').forEach(img => { img.loading = 'lazy'; });
            grid.append(document.importNode(card, true));
            seen.add(id);
          }
          next = feed.querySelector('[data-category-next]')?.getAttribute('href');
          count.textContent = `${seen.size} stories${next ? ` of ${total}` : ''}`;
        }
        if (pagination) pagination.hidden = true;
        status.textContent = `All ${seen.size} stories loaded.`;
      } catch (error) {
        status.textContent = 'Some stories could not be loaded. Try again to see the rest.';
        retry.hidden = false;
      } finally {
        running = false;
      }
    }
    retry.addEventListener('click', loadAll);
    loadAll();
  }
  document.querySelectorAll('[data-category-feed]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-category-feed]').forEach(init);
  });
})();
